import { ReactElement } from 'react';
import { NullableString } from '../../common/types';
import { CalendarActiveNew, CalendarInactiveNew } from './styles';

type CalendarReactiveIconI = {
  value: NullableString;
};

const CalendarReactiveIcon = ({
  value,
}: CalendarReactiveIconI): ReactElement => {
  return value ? <CalendarActiveNew /> : <CalendarInactiveNew />;
};

export default CalendarReactiveIcon;
